"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmartPlasticsPartApp = exports.SmartPlasticsPartAppSchema = void 0;
const tslib_1 = require("tslib");
const zod_1 = require("zod");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const SmartPlasticsPartPrismaSchema_1 = tslib_1.__importDefault(require("../../generated/zod/modelSchema/SmartPlasticsPartPrismaSchema"));
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ArticleRef_1 = require("../ArticleRef");
const ArticleType_1 = require("../ArticleType");
exports.SmartPlasticsPartAppSchema = SmartPlasticsPartPrismaSchema_1.default.extend({
    ArtNr: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    ArticleType: zod_1.z.custom((a) => a === ArticleType_1.ArticleType.zubehoer, { message: 'invalid ArticleType' }),
    Bezeichnung: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    DiscontinuedModel: zod_1.z.boolean({
        required_error: 'DiscontinuedModel is required',
        invalid_type_error: 'DiscontinuedModel must be a boolean',
    }),
    partsReferences: zod_1.z.custom(ArticleRef_1.isArticleRef, { message: 'invalid ArticleRef' }).array(),
    weight: zod_1.z.custom(echain_shared_quantities_1.isWeightJson, { message: 'invalid WeightPerLengthJson' }),
});
const isSmartPlasticsPartApp = (whatever) => {
    var _a;
    return (_a = exports.SmartPlasticsPartAppSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isSmartPlasticsPartApp = isSmartPlasticsPartApp;
//# sourceMappingURL=SmartPlasticsPartApp.js.map